import { computed, inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
  apiUrl: string;
  interval: number;
  statusInterval: number;
  secondsToShowSessionInfo: number;
  newBranding: boolean;
  templates: {
    default: string;
    fs: string;
  };
  themePaths: {
    default: string;
    fs: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private readonly http = inject(HttpClient);

  private readonly _config = signal<AppConfig | null>(null);

  readonly apiUrl = computed(() => this.config().apiUrl);
  readonly statusInterval = computed(() => this.config().statusInterval);
  readonly secondsToShowSessionInfo = computed(() => this.config().secondsToShowSessionInfo);
  readonly newBranding = computed(() => this.config().newBranding);
  readonly templates = computed(() => this.config().templates);
  readonly themePaths = computed(() => this.config().themePaths);
  readonly config = computed(() => {
    const cfg = this._config();
    if (!cfg) throw new Error('Config not loaded');
    return cfg;
  });

  async load(): Promise<void> {
    const url = `/config/config.json?ts=${Date.now()}`;
    const raw = await firstValueFrom(this.http.get<AppConfig>(url));
    this._config.set(raw);
  }
}
